var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activities !== null)?_c('span',_vm._l((_vm.sortedActivities),function(activity){return _c('span',{key:activity,staticClass:"replace-icon-by-names-on-print",attrs:{"title":_vm.$gettext(activity, 'activities')}},[_c('icon-activity',{attrs:{"activity":activity}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }